import _ from "underscore";
import SingleColumnDropdown from "./single-column-dropdown";
import ColumnsList from "../columns-picker/columns-list";

var View = ColumnsList.View.extend({
    initialize: function (options) {
        ColumnsList.View.prototype.initialize.apply(this, [options]);

        this.gridView = new SingleColumnDropdown.CollectionView({
            collection: new SingleColumnDropdown.Collection([]),
            model: this.model,
            config: options.transformationConfig,
        });

        ColumnsList.View.prototype.attachListeners.apply(this);
    },
});

var Model = ColumnsList.Model.extend({});

export default _.extend({}, ColumnsList, {
    Model: Model,
    View: View,
});
